/** Private local notes: shared checked record for the legacy web page and native app. */
(function(root, factory) {
    const notes = factory();
    if (typeof module === 'object' && module.exports) module.exports = notes;
    else root.MalkaOperatorNotes = notes;
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
    const STORAGE_KEY = 'vrs_operator_notes';
    // The server caps the complete instruction payload at 1,000 characters.
    // Leave room for caller-ID, VCO and interpreter-routing instructions.
    const MAX_LENGTH = 700;
    function ownerKey(owner) {
        if (!owner || typeof owner !== 'object' || owner.role !== 'client'
            || typeof owner.origin !== 'string' || !owner.origin.trim()
            || typeof owner.tenantId !== 'string'
            || typeof owner.userId !== 'string' || !owner.userId.trim()) return null;
        return JSON.stringify([owner.origin, owner.tenantId, owner.userId, owner.role]);
    }
    function encode(owner, text) {
        if (!ownerKey(owner) || typeof text !== 'string' || text.length > MAX_LENGTH) return null;
        return JSON.stringify({ version: 1, owner: { origin: owner.origin, tenantId: owner.tenantId,
            userId: owner.userId, role: 'client' }, text });
    }
    function read(raw, owner) {
        const key = ownerKey(owner);
        if (!key || typeof raw !== 'string') return '';
        try {
            const record = JSON.parse(raw);
            return record?.version === 1 && ownerKey(record.owner) === key
                && typeof record.text === 'string' && record.text.length <= MAX_LENGTH ? record.text : '';
        } catch { return ''; }
    }
    return { STORAGE_KEY, MAX_LENGTH, ownerKey, encode, read };
});
